import { render, staticRenderFns } from "./ProductLinkImpuestosDialog.vue?vue&type=template&id=454ed1cc&scoped=true"
import script from "./ProductLinkImpuestosDialog.vue?vue&type=script&lang=js"
export * from "./ProductLinkImpuestosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454ed1cc",
  null
  
)

export default component.exports